import styled, { css } from 'styled-components';

import { InputField } from '..';

export const OptionsContainer = styled.div`
  display: flex;
  flex-direction: column;
  position: absolute;
  left: -1px;
  right: -1px;
  background-color: #ffffff;
  border-radius: 0 0 4px 4px;
  overflow: auto;
  max-height: 184px;
  z-index: 2;
`;

export const Wrapper = styled.div`
  position: relative;
  border-radius: 4px;
  border: 1px solid #f2f4f6;

  ${(p) =>
    p.$error &&
    css`
      border: 1px solid #dd6369;
    `}

  ${InputField} {
    border: none;
  }

  ${(p) =>
    !!p.$haveData &&
    p.$focused &&
    css`
      border-radius: 4px 4px 0 0;
      border-top: 1px solid #0076be;
      border-left: 1px solid #0076be;
      border-right: 1px solid #0076be;

      ${OptionsContainer} {
        border-top: 1px solid #f2f4f6;
        border-bottom: 1px solid #0076be;
        border-left: 1px solid #0076be;
        border-right: 1px solid #0076be;
      }
    `}

  ${(p) =>
    p.$focused &&
    css`
      background-color: #ffffff;
      border: 1px solid #0076be;
    `}
`;

export const Title = styled.div`
  font-size: 16px;
  line-height: 16px;
  color: #1f2739;
`;

export const Option = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px 16px 8px 12px;
  border: 1px solid #f2f4f6;
  cursor: pointer;
  flex-shrink: 0;

  &:hover {
    background-color: #f2f4f6;
  }

  ${(p) =>
    p.$nested &&
    css`
      padding-left: 32px;
    `}

  ${Title} {
    margin-left: 8px;
  }
`;

export const ErrorMessage = styled.div`
  white-space: nowrap;
  color: #f44336;
  font-size: 10px;
  position: absolute;
  top: 48px;
`;

export const InputWrapper = styled.div``;
